import React, { useState, useCallback, useEffect, forwardRef } from 'react';
import FormControl from '@mui/joy/FormControl';
import Button from '@mui/joy/Button';
import Typography from '@mui/joy/Typography';
import Input from '@mui/joy/Input';
import FormLabel from '@mui/joy/FormLabel';


//////////////// Alert
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

///////////////// Use Form
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';


import { getSettings, updateSettings } from '../../Api/common';

const schema = yup.object({
    tax: yup.string().required("هذا الحقل مطلوب")
})


const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function TaxComponent() {
    const [content, setContent] = useState(null)
    const [loading, setLoading] = useState(false)
    const [openAlert, setOpenAlert] = useState(false);
    const [messageAlert, setMessageAlert] = useState('');

    const [openAlertError, setOpenAlertError] = useState(false);
    const [messageAlertError, setMessageAlertError] = useState('');

    const form = useForm({
        defaultValues: {
            tax: ""
        },
        resolver: yupResolver(schema)
    });
    const { register, handleSubmit, formState, setValue } = form;
    const { errors } = formState


    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlert(false);
    };

    const handleCloseAlertError = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpenAlertError(false);
    };


    const getAllContent = useCallback(async () => {
        const res = await getSettings()
        if (res) {
            setValue('tax', res.tax)
        }
    }, []);

    const submitcontent = async (data) => {
        setLoading(true)
        try {
            const res = await updateSettings(data)
            if (res) {
                setOpenAlert(true)
                setMessageAlert("تم تعديل الضريبة بنجاح")
                setLoading(false)
                getAllContent();
            }
        } catch (error) {
            if (error.response) {
                setLoading(false)
                setOpenAlertError(true)
                setMessageAlertError(error.response.data.message)
            }
        }
    }

    useEffect(() => {
        getAllContent();
    }, [getAllContent])

    return (
        <>
            <Snackbar open={openAlert} autoHideDuration={6000} onClose={handleClose}>
                <Alert severity="success">{messageAlert}</Alert>
            </Snackbar>

            <Snackbar open={openAlertError} autoHideDuration={6000} onClose={handleCloseAlertError}>
                <Alert onClose={handleCloseAlertError} severity="warning" sx={{ width: '100%' }}>
                    {messageAlertError}
                </Alert>
            </Snackbar>
            <form onSubmit={handleSubmit(submitcontent)}>
                <FormControl sx={{margin:'50px 0', width:'40%'}}>
                    <FormLabel>الضريبة</FormLabel>
                    <Input 
                        type='number' 
                        placeholder="الضريبة" 
                        sx={{
                            marginTop:'10px',
                            height:'50px',
                            borderRadius:'25px'
                        }}
                        {...register('tax')}
                        />
                    {errors.tax &&
                        <Typography
                            color="danger"
                            level="body-xs"
                            variant="plain"
                        >{errors.tax?.message}</Typography>
                    }
                </FormControl>

                <Button
                    variant='solid'
                    type='submit'
                    loading={loading}
                    sx={{ marginTop: '30px', backgroundColor: '#3E64F4', color: '#FFF', height: '60px', borderRadius: '30px' }}>
                    تجديد المحتوى
                </Button>
            </form>
        </>
    )
}